<div class="modal-content">
  <!-- Linha com endereço e valor -->
  <!-- <div class="info-principal"> -->
  <div class="esquerda">
    <p class="condominio">
      Condomínio {{this.condominio2.nome}}
    </p>
    <p class="endereco">
      {{ this.condominio2.endereco_logradouro }}, {{ this.condominio2.endereco_cidade }} </p>
  </div>

  <div class="filtro-container">
    <!-- Metragem -->
    <div class="badge metros" *ngIf="itensCondominio.minArea && itensCondominio.maxArea">
      {{ itensCondominio.minArea }}m² <span *ngIf="itensCondominio.minArea !== itensCondominio.maxArea">a {{
        itensCondominio.maxArea }}m²</span>
    </div>

    <!-- Quartos -->
    <div class="badge quartos" *ngIf="itensCondominio.quartosUnicos.length > 0">
      <i class="fa-solid fa-bed"></i>
      <span *ngIf="itensCondominio.quartosUnicos.length === 1">{{ itensCondominio.quartosUnicos[0] }} quarto</span>
      <span *ngIf="itensCondominio.quartosUnicos.length === 2">{{ itensCondominio.quartosUnicos[0] }} e {{
        itensCondominio.quartosUnicos[1] }} quartos</span>
      <span *ngIf="itensCondominio.quartosUnicos.length > 2">
        {{ itensCondominio.quartosUnicos.slice(0, -1).join(', ') }} e {{
        itensCondominio.quartosUnicos[itensCondominio.quartosUnicos.length - 1] }} quartos
      </span>
    </div>

    <!-- Vagas -->
    <div class="badge vagas" *ngIf="itensCondominio.minVagas && itensCondominio.maxVagas">
      <i class="fa-solid fa-car"></i>
      <span *ngIf="itensCondominio.minVagas === itensCondominio.maxVagas">{{ itensCondominio.minVagas }} vaga</span>
      <span *ngIf="itensCondominio.minVagas !== itensCondominio.maxVagas">{{ itensCondominio.minVagas }} e {{
        itensCondominio.maxVagas }} vagas</span>
    </div>
  </div>
</div>


<div id="carouselExample" class="carousel slide" data-bs-ride="false">
  <!-- Indicadores -->
  <div class="carousel-indicators">
    <button *ngFor="let group of groupedFotos; let i = index" [attr.data-bs-target]="'#carouselExample'"
      [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
  </div>
  <!-- Slides -->
  <div class="carousel-inner">
    <div *ngFor="let group of groupedFotos; let i = index" class="carousel-item" [class.active]="i === 0">
      <div class="row">
        <div [class.col-12]="mobile" [class.col-4]="!mobile" *ngFor="let foto of group">
          <img [src]="foto.link" class="d-block w-100" alt="Imagem {{ i + 1 }}"
            style="height: 65vh; background: #cdcdcd; object-fit: cover;">
        </div>
      </div>
    </div>
  </div>
  <!-- Controles de navegação -->
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<div class="detalhes-imovel-container">
  <!-- Parte Principal -->
  <div class="conteudo-principal">
    <!-- Linha dos botões -->
    <div class="botoes">
      <button class="botao ativo" (click)="abreGaleria()">Fotos</button>
      <button class="botao" *ngIf="this.existeVideo" style="border: 1.5px solid #535353;"
        (click)="abreApresentacao()">Vídeo</button>
      <!-- <button class="botao" style="border: 1.5px solid #535353;">Tour Virtual</button> -->
      <button class="botao" style="color: #d71614!important;" id="fullscreen-map-btn-desktop">Ver Mapa</button>
    </div>


    <!-- Frame do mapa -->
    <div class="mapa">
      <!-- Botão de fechar visível somente no modo tela cheia -->
      <div id="map" style="width: 100%; height: 250px;"></div>
    </div>

    <!-- Título -->
    <!-- <h2 class="titulo">{{ imovel?.titulo }}</h2> -->

    <!-- Descrição -->
    <p class="descricao">
      <!-- {{ imovel?.descricaoPrincipal }} -->
      {{ imoveis2[0]?.observacoes }}
    </p>

    <!-- <div class="grid-table">
          <div class="row">
            <div><strong>Tipo</strong> {{ imoveis[0].destinacao }}</div>
            <div><strong>Subtipo</strong> {{ imoveis[0].tipo }}</div>
          </div>
          <div class="row">
            <div style="justify-content: space-between!important;" *ngIf="imoveis[0].areaLote != '0,00'"><strong>Área total</strong> {{ imoveis[0].areaLote }} m²</div>
            <div style="justify-content: space-between!important;" *ngIf="imoveis[0].areaLote == '0,00'"><strong>Área total</strong> {{ imoveis[0].areaExterna }} m²</div>
            <div style="justify-content: space-between!important;"><strong>Área privativa</strong> {{ imoveis[0].areaInterna }} m²</div>
          </div>
        </div>       -->

    <!-- <div class="caracteristicas-container" *ngIf="caracteristicas.length > 0">
      <div class="caracteristica" *ngFor="let caracteristica of caracteristicas">
        <i class="fas fa-check"></i> {{ caracteristica }}
      </div>
    </div> -->

    <app-comodidades [comodidades]="this.condominio2.infraestruturas"></app-comodidades>
  </div>

  <!-- Parte Lateral Flutuante -->
  <div class="conteudo-lateral">
    <div class="box">
      <div class="cabecalho-chamada-texto">
        <h3>Busca um imóvel neste condomínio?</h3>
        <p>Deixe um de nossos corretores te ajudar.</p>
      </div>

      <div class="area-caracteristicas">

      </div>

      <form [formGroup]="leadForm" (ngSubmit)="enviarLead()">
        <div class="form-container">

          <!-- Nome -->
          <div class="form-group">
            <label for="nome">Nome</label>
            <input type="text" id="nome" formControlName="nome" placeholder="Coloque seu nome aqui" />
          </div>

          <!-- E-mail -->
          <div class="form-group">
            <label for="email">E-mail</label>
            <input type="email" id="email" formControlName="email" placeholder="Coloque seu melhor e-mail" />
          </div>

          <!-- Telefone -->
          <div class="form-group">
            <label for="telefone">Telefone</label>
            <input type="tel" id="telefone" formControlName="telefone" placeholder="Coloque seu número de WhatsApp" />
          </div>

          <div style="display: flex; gap: 10px;">
            <!-- Botão para enviar o formulário -->
            <button class="btn btn-primary" type="submit">Contatar Corretor</button>

            <!-- Botão para abrir o WhatsApp -->
            <button class="btn btn-success" type="button" (click)="openWhatsApp()">Falar no WhatsApp</button>
          </div>

        </div>
      </form>
    </div>
    <div style="padding:15px;"></div>
    <!-- Parte Lateral Flutuante -->
    <!-- <div class="box">
          <div class="cabecalho-lateral">
            <div style="display: flex; width: 30%; justify-content: end;">
              <div class="corretor">
                <img [src]="imagemCorretor"/>
              </div>
            </div>
  
            <div class="cabecalho-corretor-texto">
              <h3>{{nomeCorretor}}</h3>
              <p>Corretor de imóveis</p>
            </div>
          </div>
  
          <div class="div-img-texto-corretor">
            <div class="div-corretor-icon">
              <i class="fa-sharp fa-solid fa-envelope"></i>
              <i class="fa-brands fa-whatsapp"></i>
            </div>
          </div>
  
        </div> -->

  </div>
</div>



<div class="content-2" style="margin: auto!important;">
  <h1 class="title-2">
    Imóveis disponíveis {{imoveis[0]?.nomeCondominio}}<br>
    <div class="style-div"></div>
  </h1>
</div>

<div style="display: block; justify-content: center; width: 100%;">

  <div *ngIf="quantidade2 === 0"
    style="display: flex; justify-content: center; font-size: 40px; color:#858585; margin: 10vh auto;">
    Nenhum imóvel foi encontrado
  </div>
  <div class="body-lista">
    <div class="cards"
      [ngClass]="{'overlay-opened': gridState === 'overlay-opened','overlay-filter-open': gridState === 'filter-open'}">
      <div class="card-destaque" *ngFor="let imovel of imoveis2">
        <div class="header-card">
          <div class="div-img">
            <!-- <img [src]="imovel?.imagens[0]?.link_thumb" alt="Imagem" class="image-card"> -->
            <app-swiper-imagens [imovel]="imovel" [imagens]="imovel.imagens" [imovelSlug]="imovel.slug"></app-swiper-imagens>
          </div>
        </div>
        <div class="body-card" (click)="abreImovel(imovel?.slug)">
          <p class="tipo"><span><b>{{ imovel?.subtipo }}</b></span><span style="font-size: 13px;">{{ imovel?.codigo
              }}</span></p>
          <!-- endereco -->
          <p class="titulo">{{ imovel | enderecoImovel }}</p>


          <div
            style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: start; letter-spacing: -0.3px;">
            <div>
              <p class="valor">{{ (imovel?.valor_locacao || imovel?.valor_venda) | currency: 'BRL' }}<span
                  *ngIf="imovel?.valor_locacao">/mês</span></p>
            </div>
            <div class="div-icones-imovel">

              <p
                *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'">
                <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>
              </p>

              <p *ngIf="imovel.subtipo | deveExibirAtributo: 'terreno_total'">
                <b>{{ (imovel?.terreno_total ?? imovel?.area_privativa) | number:'1.0-0' }} {{imovel.medida}} </b>
                <br />
              </p>

              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
                *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                style="margin: 0px 5px 0 5px;">
                <p>
                  <b>{{ imovel?.dormitorios }}</b>
                  <sup *ngIf="imovel?.suites && imovel.suites > 0" style="font-weight: 600; font-size: 0.75em;">{{
                    imovel.suites }}</sup>
                  <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                </p>
              </div>

              <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                <p>
                  <b>{{ imovel?.banheiros ?? 0 }}</b>
                  <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>

                </p>
              </div>
              <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                <p>
                  <b>{{ imovel?.garagens ?? 0 }}</b>
                  <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                </p>
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>

  </div>


  <div style="display: flex; justify-content: space-around; margin: 35px 0;">

    <div class="paginacao" *ngIf="quantidade2 > 0">
      <button (click)="previousPage()" class="pag-button" [disabled]="buscaResponse?.page === 1"
        style="margin-right: 40px;">
        <svg style="display: flex; margin-left: -3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30"
          height="25" [ngStyle]="{'fill': getSvgColor(), 'stroke': getSvgColor()}" stroke-width="2" class="size-1"
          transform="scale(-1, 1)">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </button>

      <div *ngFor="let page of getPages()" style="margin: 0; width: 50px; font-weight: 600; font-size: 20px;">
        <button class="pag-button" style="box-shadow: none!important;" mat-button
          [disabled]="buscaResponse?.page == page" (click)="navigateToPage(page)">
          {{ page }}
        </button>
      </div>

      <button (click)="nextPage()" class="pag-button" [disabled]="buscaResponse?.page === buscaResponse?.totalPages"
        style="margin-left: 40px;">
        <svg style="display: flex; margin-left: 3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30"
          height="26" [ngStyle]="{'fill': getSvgColorEnd(), 'stroke': getSvgColorEnd()}" stroke-width="2"
          class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>


  <!-- <div class="overlay" [ngClass]="{ 'overlay-open': isOverlayOpen }">
      <div class="map" id=>
        <iframe
        width="100%"
        height="100%"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
      </div> -->

  <div class="overlay" [ngClass]="{ 'overlay-open': isOverlayOpen }">
    <div class="maps" id="map"></div>
  </div>
</div>
<!-- <div class="body-lista">
  <div class="cards">
    <div class="card-destaque" *ngFor="let imovel of imoveis" (click)="abreImovel(imovel.codigo)">
      <div class="header-card">
        <div class="div-img">
          <img [src]="imovel.urlFotoPrincipalM" alt="Imagem" class="image-card">
        </div>
      </div>
      <div class="body-card">
        <p class="tipo"><span><b>{{ imovel.tipo }}</b></span><span style="font-size: 13px;">(Cód. {{ imovel.codigo
            }})</span></p>
        <p class="titulo">{{ imovel.endereco }}, {{ imovel.bairro }} - {{ imovel.cidade }}, {{ imovel.estado }}</p>
        <div class="div-icones-geral">
          <p class="valor">{{ imovel.valor }}</p>
          <div class="div-icones-imovel">
            <p>
              <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
              <b>{{ imovel.areaPrincipal }} m²</b>
            </p>
            <p>
              <i class="fa-solid fa-bed"></i>
              <b>{{ imovel.numeroQuartos }}</b>
            </p>
            <p>
              <i class="fa-solid fa-shower"></i>
              <b>{{ imovel.numeroBanhos }}</b>
            </p>
            <p>
              <i class="fa-solid fa-car"></i>
              <b>{{ imovel.numeroVagas }}</b>
            </p>
          </div>
        </div>
      </div>


    </div>
  </div>
</div> -->


<app-loader [isLoading]="isLoading">

</app-loader>